import { render, staticRenderFns } from "./allment.vue?vue&type=template&id=a945d208&scoped=true&"
import script from "./allment.vue?vue&type=script&lang=js&"
export * from "./allment.vue?vue&type=script&lang=js&"
import style0 from "./allment.vue?vue&type=style&index=0&id=a945d208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a945d208",
  null
  
)

export default component.exports